import { render, staticRenderFns } from "./ClubHouseIcon.vue?vue&type=template&id=3ed2fb21&"
import script from "./ClubHouseIcon.vue?vue&type=script&lang=js&"
export * from "./ClubHouseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports